import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/exam_title.png'
import _imports_1 from '@/assets/currency/left.png'
import _imports_2 from '@/assets/currency/right.png'


const _withScopeId = n => (_pushScopeId("data-v-56c9e94c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = { class: "dvContent" }
const _hoisted_3 = { class: "dvTop" }
const _hoisted_4 = { class: "dvTopLeft" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftLogo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dvTopLeftLogoImg",
    src: _imports_0
  })
], -1))
const _hoisted_6 = { class: "dvTopLeftTitle ml1" }
const _hoisted_7 = { class: "dvMid" }
const _hoisted_8 = { class: "dvMidTop" }
const _hoisted_9 = {
  key: 0,
  class: "dvMidTopTxt"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "dvCoverList" }
const _hoisted_12 = { class: "dvCoverTitle" }
const _hoisted_13 = { class: "dvCoverExam" }
const _hoisted_14 = { class: "dvCoverExamTitle" }
const _hoisted_15 = { class: "dvCoverExamTime" }
const _hoisted_16 = {
  key: 0,
  class: "dvCoverScores"
}
const _hoisted_17 = {
  key: 1,
  class: "dvCoverNoScores"
}
const _hoisted_18 = {
  key: 0,
  class: "dvMidBottom"
}
const _hoisted_19 = { class: "dvpage" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dvImg",
  src: _imports_1
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "dvTxt fontSize32 colorF" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dvImg",
  src: _imports_2
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "dvBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.titleTopTxt), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.examThree.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.titleTxt), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.examThree, (exam, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["dvCoverListBS", [index > 1 ? 'mt32' : '']]),
                  key: exam.id,
                  onClick: ($event: any) => (_ctx.goPaper(exam))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(exam.exam.name), 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(exam.finished_at), 1)
                      ]),
                      (exam.status === 2 || _ctx.type === 'mockExam')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(exam.score) + " 分 ", 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, "待打分"))
                    ])
                  ])
                ], 10, _hoisted_10))
              }), 128))
        ]),
        (_ctx.examThree.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: "dvIcon",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)))
                }, _hoisted_21),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.current_page) + " / " + _toDisplayString(_ctx.total), 1),
                _createElementVNode("div", {
                  class: "dvIcon",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                }, _hoisted_24)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          class: "btnBack",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, "返 回")
      ])
    ])
  ]))
}